import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export const shrinkString = ({
  text,
  length,
  dot_count = 3,
}: {
  text: string;
  length: number;
  dot_count?: number;
}): string => {
  if (!text) return "";
  if (text.length <= length) return text;

  const dots = ".".repeat(dot_count);
  return text.substring(0, length - dot_count) + dots;
};

export const getInitials = (name: string): string => {
  return name
    .split(" ")
    .map((part) => part.charAt(0))
    .join("")
    .toUpperCase()
    .substring(0, 2);
};

export const getRandomColorForPath = (path: string): string => {
  const colors = [
    "#FF5733",
    "#33FF57",
    "#3357FF",
    "#FF33A8",
    "#A833FF",
    "#FF8C33",
    "#33FFF5",
    "#8C33FF",
    "#33FF8C",
    "#FF338C",
  ];

  let hash = 0;
  for (let i = 0; i < path.length; i++) {
    hash = path.charCodeAt(i) + ((hash << 5) - hash);
  }

  const index = Math.abs(hash) % colors.length;
  return colors[index];
};

export const getDaysDifference = (startDate: string, endDate: string) => {
  const start = startDate ? new Date(startDate) : new Date();
  const end = new Date(endDate);

  if (isNaN(start.getTime()) || isNaN(end.getTime())) return null;

  const diffMs = end.getTime() - start.getTime();
  const days = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

  return days;
};

export function spaceToDash(text: string): string {
  return text.replace(/ /g, "-");
}

export function dashToSpace(text: string): string {
  return text.replace(/-/g, " ");
}
